import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import crypto from "crypto-js";

export function cryptoDecryptData(encryptedData: string): any {
	try {
		const secretKeyEnCrypt = import.meta.env.VITE_COMPANY_ENCRYPTION_KEY as string;
		const decrypted = crypto.AES.decrypt(encryptedData, secretKeyEnCrypt);
		const decryptedString = decrypted.toString(crypto.enc.Utf8);
		if (!decryptedString) {
			throw new Error("Decryption failed - invalid key or corrupted data");
		}
		return JSON.parse(decryptedString);
	} catch (error) {
		throw new Error(error);
	}
}

export const baseQueryWithDecryption = (
	baseUrl: string,
	options?: { apiKey?: string }
) => {
	const dynamicRawBaseQuery = fetchBaseQuery({
		baseUrl,
		credentials: "include",
		prepareHeaders: (headers) => {
			headers.set("Content-Type", "application/json");
			// if (options?.apiKey) {
			// 	headers.set("x-api-key", options.apiKey);
			// }
			// headers.set("accesstoken", localStorage.getItem("accessToken") || "");
			return headers;
		},
	});

	return async (args: any, api: any, extraOptions: any) => {
		const result = await dynamicRawBaseQuery(args, api, extraOptions);
		if (result && "data" in result) {
			const response: any = (result as any).data;
			if (response && typeof response === "object" && "data" in response) {
				const innerData = (response as any).data || {};
				const encryptedData = innerData?.encryptedData ?? innerData?.encryptData;

				if (encryptedData && typeof encryptedData === "string") {
					try {
						const decryptedUtf8 = cryptoDecryptData(encryptedData);
						if (!decryptedUtf8) {
							return result;
						}

						let decryptedParsed: any = decryptedUtf8;
						try {
							decryptedParsed = JSON.parse(decryptedUtf8);
						} catch {
							// keep as string if not JSON
						}

						(result as any).data = {
							...response,
							data: {
								...innerData,
								decryptedData: decryptedParsed,
								localData: decryptedParsed,
							},
						};
					} catch (error) {
						console.log("error in decryption", error);
						// leave original data if decryption fails
					}
				}
			}
		}
		return result;
	};
};
